<script lang="ts">
	import NiceAudio from '$lib/NiceAudio.svelte';
	import { ArrowRight } from '@lucide/svelte';

	let {
		urlBefore,
		urlAfter
	}: {
		urlBefore: string;
		urlAfter: string;
	} = $props();
</script>

<div class="card preset-tonal-outlined flex flex-col overflow-hidden shadow">
	<div class="flex flex-row justify-stretch gap-2 p-2 md:gap-4 md:p-4 lg:flex-row">
		<div class="flex w-full flex-col justify-center rounded-xl shadow">
			<NiceAudio
				class="h-20 md:h-28"
				url={urlBefore}
				name="Before"
				peaksUrl={`${urlBefore}.peaks.json`}
				downloadHidden
				variant="ghost"
			/>
		</div>
		<div class="text-foreground flex items-center"><ArrowRight /></div>
		<div class="flex w-full flex-col rounded-xl shadow">
			<NiceAudio
				class="h-20 md:h-28"
				url={urlAfter}
				name="After"
				peaksUrl={`${urlAfter}.peaks.json`}
				downloadHidden
				variant="ghost"
			/>
		</div>
	</div>
</div>
